import React, { useEffect, useState } from 'react'

import MainTitle from "../../modules/shared/components/MainTitle"
import { useBuscaOcorrenciasParaAssociados } from '../../modules/ocorrencia/hooks/useBuscaOcorrenciasParaAssociados'
import MultiMatchFilter from '../../modules/shared/components/CampoMultiplosInputs/MatchFilter/MultiMatchFilter'
import TabelaOcorrenciasAnonimas from '../../modules/ocorrencia/components/TabelaOcorrenciasAnonimas/TabelaOcorrenciasAnonimas'
import { retornaListaMatchPorListaCampo } from '../../Utilitarios'

const opcoesDeFiltro = [
    'Dano Reclamado',
    'Data Ocorrência',
    'Instrução Limpeza',
    'Limpeza Utilizada',
    'Marcas',
    'Peças',
    'Responsável',
]

const campoPorOpcao = {
    'Dano Reclamado': 'damage',
    'Peças': 'items',
    'Marcas': 'brands',
    'Data Ocorrência': 'ocurrence_date',
    'Instrução Limpeza': 'wash_instruct',
    'Limpeza Utilizada': 'wash_used',
    'Responsável': 'responsible',
}

const criaFiltroVazio = () => ({
    id: `${Date.now()}-${Math.random()}`,
    campo: "",
    valor: "",
})

export default function Relatorios() {
    const [filtrado, setFiltrado] = useState([])
    const [listaOcorrenciasCompleta, setListaOcorrenciasCompleta] = useState([])
    const [filtros, setFiltros] = useState([criaFiltroVazio()])

    const [resposta, buscaOcorrencias] = useBuscaOcorrenciasParaAssociados()

    useEffect(() => {
        buscaOcorrencias()
    }, [buscaOcorrencias])

    useEffect(() => {
        if(Object.entries(resposta).length > 0) {
            const listaTabela = resposta.data.map(value => {
                const { listaPecas, listaMarcas, ocorrencia } = value
                return {
                    id: ocorrencia.getId(),
                    damage: ocorrencia.getDanoReclamado(),
                    ocurrence_date: ocorrencia.getDataOcorrencia(),
                    wash_used: ocorrencia.getInstrucaoLimpeza(),
                    wash_instruct: ocorrencia.getLimpezaUtilizada(),
                    responsible: ocorrencia.getResponsavel(),
                    items: listaPecas.listaNomePecas,
                    brands: listaMarcas.listaNomeMarcas
                }
            })
            setFiltrado(listaTabela)
            setListaOcorrenciasCompleta(listaTabela)
        }
    }, [resposta])

    useEffect(() => {
        const filtrosPreenchidos = filtros.filter(filtro => filtro.campo !== "" && filtro.valor !== "")

        if(filtrosPreenchidos.length === 0) {
            setFiltrado(listaOcorrenciasCompleta)
            return
        }

        const novaLista = filtrosPreenchidos.reduce((listaAtual, filtro) => {
            return retornaListaMatchPorListaCampo(listaAtual, campoPorOpcao[filtro.campo], filtro.valor)
        }, listaOcorrenciasCompleta)

        setFiltrado(novaLista)
    }, [filtros, listaOcorrenciasCompleta])

    const handleAdicionarFiltro = () => {
        setFiltros(filtrosAtuais => [...filtrosAtuais, criaFiltroVazio()])
    }

    const handleAlterarFiltro = (id, novoValor) => {
        setFiltros(filtrosAtuais => filtrosAtuais.map(filtro => {
            if(filtro.id !== id) return filtro
            return { ...filtro, ...novoValor }
        }))
    }

    const handleRemoverFiltro = (id) => {
        setFiltros(filtrosAtuais => {
            const novaLista = filtrosAtuais.filter(filtro => filtro.id !== id)
            return novaLista.length > 0 ? novaLista : [criaFiltroVazio()]
        })
    }

    return (
        <>
            <MainTitle titulo="Relatórios de ocorrência" tituloPrincipal />
            <MultiMatchFilter
                filtros={filtros}
                itensDoSelect={opcoesDeFiltro}
                onAdicionarFiltro={handleAdicionarFiltro}
                onAlterarFiltro={handleAlterarFiltro}
                onRemoverFiltro={handleRemoverFiltro}
            />
            <TabelaOcorrenciasAnonimas
                ocorrencias={filtrado}
                onClick={() => {}} />
        </>
    )
}
